<template>
  <el-container>
    <el-header
      :height="headerheight"
      style="position: sticky; top: 0; z-index: 999"
    >
      <div class="nav">
        <div class="platform">
          <img
            v-if="isHeaderFrom"
            :src="header"
            alt="中模系统"
            class="logo header-logo"
            @click="$router.push({ path: '/' })"
          />
          <div v-else class="brand-logo" @click="$router.push({ path: '/' })">
            <img :src="logo" alt="中模" class="brand-icon" />
            <span class="brand-name">中模·promold</span>
          </div>
        </div>
        <ul class="u-flex">
          <li
            :class="{ active: active == item.value }"
            @click="handleItem(item)"
            v-for="(item, index) in tabs"
            :key="index"
          >
            {{ item.label }}
          </li>
        </ul>
        <div class="loginRegister">
          <span class="login" @click="login">登录</span>
          <span class="register" @click="register">注册</span>
        </div>
      </div>
    </el-header>
    <eb-main ref="ebMain"></eb-main>
    <eb-footer></eb-footer>
    <backtop></backtop>
  </el-container>
</template>

<script>
import header from "../../assets/header.png";
import logo from "../../assets/logo.png";
import EbMain from "./EbMain";
import EbFooter from "./EbFooter";

import backtop from "../backTop/index";
import qqQR from "../../assets/qq_QR.png";
import wechatQR from "../../assets/wechat_QR.png";
import follow from "../../assets/follow.png";
import { downloadFile } from "@/utils/util";

export default {
  name: "Layout",
  data() {
    return {
      header,
      logo,
      qqQR,
      wechatQR,
      follow,
      headerheight: "65px",
      active: "Home",
      tabs: [
        {
          label: "首页",
          isPage: true,
          value: "Home",
        },
        {
          label: "产品中心",
          isPage: true,
          value: "productCenter",
        },
        {
          label: "新闻动态",
          isPage: true,
          value: "newsUpdates",
        },
        {
          label: "客户案例",
          isPage: true,
          value: "Customer",
        },
    
        {
          label: "关于我们",
          isPage: true,
          value: "contactUs",
        },
        {
          label: "加入我们",
          isPage: true,
          value: "setPrice",
        }, 
      ],

      // 功能更新
      updateModal: {
        visible: false,
        dataSource: [],
      },
      // 联系我们
      contactUsModal: {
        visible: false,
      },
      // 软件下载
      downloadModal: {
        visible: false,
        dataSource: [],
      },
    };
  },
  watch: {
    $route(to) {
      this.active = to.name;
    },
  },
  components: {
    EbMain,
    EbFooter,
    backtop,
  },
  created() {
    this.active = this.$route.name;
  },
  computed: {
    isHeaderFrom() {
      return this.$route.query.from === "yun";
    },
  },
  methods: {
    isYunFrom() {
      return this.$route.query.from === "yun";
    },
    login() {
      window.location.href = this.isYunFrom()
        ? "https://yun.mould.cn/loginView.html"
        : "https://yun.mould.cn/yunLoginView";
    },
    register() {
      window.location.href = this.isYunFrom()
        ? "https://yun.mould.cn/register.html"
        : "https://www.promold.net/yunRegisterView";
    },
    handleItem(item) {
      this.active = item.value;
      this.$router.push({ name: item.value });
    },
    downloadFile,
  },
};
</script>

<style lang="scss" scoped>
@mixin backgroundImage($url) {
  background-image: url($url);
  background-repeat: no-repeat;
  background-size: 100%;
}

.nav {
  // width: 1920px;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  height: 100%;
  &:hover {
    background-color: #ffffff;
  }
}
.platform {
  width: 260px;
  height: 48px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.header-logo {
  display: block;
}
.brand-logo {
  display: flex;
  align-items: center;
  height: 100%;
}
.brand-icon {
  width: 36px;
  height: 36px;
  object-fit: contain;
  flex: 0 0 auto;
}
.brand-name {
  margin-left: 12px;
  font-size: 26px;
  line-height: 1;
  font-weight: 700;
  color: #000a25;
  white-space: nowrap;
}
h1 {
  font-weight: bold;
      font-size: 25px;
}
ul {
  height: 100%;
  margin-left: 80px;
  li {
    width: 120px;
    height: 100%;
    font-size: 16px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover,
    &.active {
      color: #005CEF;
      position: relative;
      font-weight: 700;

    }
  }
}
.loginRegister {
  margin-left: auto;
  display: flex;
  align-items: center;

  span {
    font-size: 16px;
    cursor: pointer;
    width: 112px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .login {
    color: #005cef;
    background: #ffffff;
    border: 1px solid #005cef;
    margin-left: 0;
    border-radius: 4px 4px 4px 4px;
  }

  .register {
    color: #ffffff;
    background: #005cef;
    border-radius: 4px;
    margin-left: 20px;
    border-radius: 4px 4px 4px 4px;
  }
}

.update-modal {
  .container {
    border-top: 1px solid #e1e4eb;
    padding: 16px 20px;
  }
  .card {
    background: linear-gradient(137deg, #f14870 0%, #a11639 100%);
    border-radius: 12px;
    color: #ffffff;
    position: relative;
    padding: 38px 18px 77px 28px;
    margin-bottom: 16px;

    &::before {
      content: "";
      width: 52px;
      height: 46px;
      position: absolute;
      top: 16px;
      left: 16px;
      @include backgroundImage("../../assets/update1.png");
    }

    &::after {
      content: "";
      width: 98px;
      height: 97px;
      position: absolute;
      right: 12px;
      bottom: 0;
      @include backgroundImage("../../assets/update2.png");
    }

    p {
      position: relative;
      font-weight: bold;
      line-height: 32px;
      font-size: 16px;
    }
  }

  ul {
    padding-top: 16px;
    border-top: 1px solid #e1e4eb;
    li {
      margin-bottom: 24px;
      .title {
        margin-bottom: 12px;
      }

      .content {
        display: flex;
        &:hover {
          color: #295bce;
        }
      }

      .icon-update {
        width: 16px;
        height: 16px;
        margin: 0 8px;
        display: inline-block;
        @include backgroundImage("../../assets/update.png");
      }
    }
  }
}

.contact_us-modal {
  .container {
    border-top: 1px solid #e1e4eb;
    padding: 20px;
  }
  h3 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 18px;
  }
  .contact {
    li {
      color: #000219;
      font-size: 16px;
      margin-bottom: 20px;
    }
  }
  .img {
    display: flex;
    li {
      margin-right: 45px;
      text-align: center;

      p {
        margin-top: 10px;
        color: #858a9d;
      }
    }
    img {
      width: 90px;
      height: 90px;
    }
  }
}

.download-modal {
  .container {
    border-top: 1px solid #e1e4eb;
    padding: 16px 20px;

    li {
      color: #000219;
      font-size: 16px;
      line-height: 30px;
      border-bottom: 1px solid #e1e4eb;

      &:hover {
        color: #295bce;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>
